export default class View {
  _data;

  render(data) {
    this._data = data;
    console.log(this._data);
    this._clear();
    const markup = this._generateMarkup();
    this._area.insertAdjacentHTML('afterend', markup);
  }

  _clear() {
    const empBox = '';
    this._area.insertAdjacentHTML('afterend', empBox);
  }

  prof() {
    console.log(this.name, this.sex, this.height);
  }
}
